<template>
  <div class>
    <section class="sticky w-full top-0 z-10 bg-greyBackground pb-4">
      <article class="flex justify-between pb-4 pt-8 items-center md:justify-center">
        <div class="flex gap-2 items-baseline">
          <h1 v-if="showPending" class="justify-self-center heading-text">Statements</h1>
          <h1 v-else class="justify-self-center heading-text">Dues & Bills</h1>
        </div>
        <img
          class="block h-5 md:h-8 w-auto md:hidden"
          src="../assets/logo-primary.svg"
          alt="ePayLater"
          width="132"
          height="28"
        />
      </article>
      <section class="flex mt-4">
        <button
          class="rounded-l-xl border px-8 py-2 text-xs font-normal focus:outline-none w-full"
          :class="
            showPending
              ? 'border-primaryLight text-white bg-primaryLight text-base capitalize font-blogger'
              : 'border-greyButtonColor bg-greyButtonColor text-black text-base capitalize font-blogger'
          "
          @click.prevent="
          showSettled = false;
          showPending = true;
          "
        >Pending Dues</button>
        <button
          class="rounded-r-xl border px-8 py-2 font-normal text-xs focus:outline-none w-full"
          :class="
            showSettled
              ? 'border-primaryLight text-white bg-primaryLight text-base capitalize font-blogger'
              : 'border-greyButtonColor bg-greyButtonColor text-black text-base capitalize font-blogger'
          "
          @click.prevent="
          showSettled = true;
          showPending = false;
          "
        >Settled Bills</button>
      </section>
    </section>
    <div class="overflow-auto">
      <!-- Pending Dues -->
      <template v-if="showPending">
        <div class="grid gap-3 pb-6" v-if="transactions?.pendingTransactions?.unpaidTxnCount">
          <section
            @click.prevent="transactionPassCreditStatement(transaction)"
            class="grid bg-white shadow-cardShadow py-4 rounded-lg cursor-pointer"
            v-for="(transaction, index) in transactions?.pendingTransactions
            ?.unsettledTransactionList"
            :key="index"
          >
            <article class="flex justify-between gap-4 items-center px-4 pb-2">
              <p
                class="capitalize bg-hyperLinkColor rounded-full w-9 h-9 flex items-center justify-center text-base font-semibold text-white font-blogger pt-1"
              >
                {{ transaction.marketplaceName?.trim().charAt(0) }}
              </p>
              <div class="flex-1">
                <p class="label-text-medium overflow-ellipsis overflow-hidden whitespace-nowrap w-20">{{ transaction?.marketplaceName }}</p>
                <p class="text-successColor text-base capitalize font-blogger">{{ $filters.formatMoney(transaction?.txnAmount) }}</p>
              </div>
              <div class="grid justify-items-end">
                <p>
                  <span class="secondary-heading-text-blogger">Total Pay:</span> <span class="text-successColor text-xs font-blogger">
                    {{ $filters.formatMoney(transaction?.txnAmount + transaction?.txnConvenienceFees + transaction?.txnLateFees + transaction?.txnPenaltyFees) }}
                  </span>
                </p>
                <card v-if='false' class="flex gap-1">
                  <div class="w-auto h-4">
                    <Vue3Lottie :animationData="AlertErrorAnimation" :speed="1" :loop="true" />
                  </div>
                  <p class="text-xs capitalize font-semibold text-errorColor font-blogger">Over Due by 3 Days</p>
                </card>
                <card v-if='false'>
                  <p class="text-alertColor font-blogger text-xs">Due In 6 Days</p>
                </card>
                <card>
                  <p class="text-greyDueDateColor text-xs font-blogger">Due Date: {{ $filters.formatDate(transaction.txnDueDate) }}</p>
                </card>
              </div>
            </article>
            <hr/>
            <article class="flex justify-between px-4 pt-2">
              <div>
                <p class="text-errorColor text-base capitalize font-semibold font-blogger">{{ $filters.formatMoney(transaction.netPayableAmount) }}</p>
                <p class="secondary-headingColor-text-blogger">Total Due</p>
              </div>
              <div class="grid items-center">
                <button class="w-20 h-7 rounded-full font-bold bg-successColor text-black text-xxs font-blogger shadow-payNowShadow paddingTop1px" variant="primary" type="button">
                  Pay Now
                </button>
              </div>
            </article>
          </section>
            <Observer @intersect="intersected" />
            <loader
              :loading="isLoading"
              v-if="isLoading"
              variant="primary"
              class="justify-self-center"
            />
        </div>
        <no-data-available v-else imageName="no-transactions.png" message="No transactions yet" class="grid"/>
      </template>
      <!-- Settled Bills -->
      <template v-if="showSettled">
        <div class="pb-6" v-if="transactions?.settledTransactions?.availableSettledTxns">
          <section
            class="grid gap-4 mb-4 mt-2"
            v-for="(transaction, index) in transactions?.settledTransactions
            ?.settledTransactionList"
            :key="index"
          >
            <router-link
              :to="{
                name: 'Credit Statement Transaction Details',
                params: { ...transaction },
              }"
              class="flex justify-between gap-4 rounded-lg items-center bg-no-repeat bg-white p-4 shadow-cardShadow"
            >
              <p
                class="capitalize bg-hyperLinkColor rounded-full w-9 h-9 flex items-center justify-center text-base font-semibold text-white font-blogger pt-1"
              >{{ transaction.marketplaceName?.trim().charAt(0) }}</p>
              <div class="flex-1">
                <p class="label-text-medium">{{ transaction.marketplaceName }}</p>
                <p class="label-text-medium">{{ $filters.formatMoney(transaction.paidAmount) }}</p>
              </div>
              <div class="grid justify-items-end">
                <p class="secondary-heading-text-blogger">
                  Settled Date: {{ $filters.formatDate(transaction.txnDate) }}
                </p>
                <p class="secondary-heading-text-blogger">
                  Transaction Date: {{ $filters.formatDate(transaction.txnDate) }}
                </p>
              </div>
            </router-link>
          </section>
          <section class="grid">
            <Observer @intersect="intersected" />
            <loader
              :loading="isLoading"
              v-if="isLoading"
              variant="primary"
              class="justify-self-center"
            />
          </section>
        </div>
        <no-data-available v-else imageName="no-transactions.png" message="No transactions yet" class="grid"/>
      </template>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import NoDataAvailable from './NoDataAvailable.vue';
import Loader from './Loader.vue';
import Observer from './Observer.vue';
import AlertErrorAnimation from '../assets/animation/Alert-Error-Animation.json';

export default {
  name: 'CreditStatementTransactions',
  components: {
    NoDataAvailable,
    Loader,
    Observer,
  },
  computed: {
    ...mapGetters(['uuid']),
  },
  props: {
    creditStatementDataProps: {
        type: Object,
    },
  },
  data() {
    return {
      showPending: true,
      showSettled: false,
      count: 10,
      pendingTransactionCount: undefined,
      settledTransactionCount: undefined,
      transactions: undefined,
      isLoading: false,
      AlertErrorAnimation,
      start: 0,
      textColorFirstLetter: [
        "#F45C5F",
        "#6AC259",
        "#377CFD",
        "#FD7F5B"
      ]
    };
  },
  mounted() {
    this.getCustomerTransactionDetails();
  },
  watch: {
    showPending() {
      this.start = 0;
      this.transactions = undefined;
      this.getCustomerTransactionDetails();
    },
  },
  methods: {
    intersected() {
      if (!this.isLoading && this.start) {
        if (
          (this.showPending &&
            this.start <
            this.transactions.pendingTransactions.unpaidTxnCount) ||
          (this.showSettled &&
            this.start <
            this.transactions.settledTransactions.availableSettledTxns)
        ) {
          this.getCustomerTransactionDetails();
        }
      }
    },
    transactionPassCreditStatement(e) {
      this.$router.push({
        name: 'Credit Statement Pay Now',
        query: { transactionId: e.id, }
      });
    },
    getCustomerTransactionDetails() {
      this.isLoading = true;
      this.$store
        .dispatch('customerTransactionDetails', {
          uuid: this.uuid,
          urlParams: {
            start: this.start,
            count: this.count,
          },
        })
        .then((response) => {
          if (this.start) {
            if (
              this.showPending &&
              this.start < this.transactions.pendingTransactions.unpaidTxnCount
            ) {
              this.transactions.pendingTransactions.unsettledTransactionList.push(
                ...response.pendingTransactions.unsettledTransactionList
              );
              this.start +=
                response.pendingTransactions.unsettledTransactionList?.length;
            } else if (
              this.showSettled &&
              this.start <
              this.transactions.settledTransactions.availableSettledTxns
            ) {
              this.transactions.settledTransactions.settledTransactionList.push(
                ...response.settledTransactions.settledTransactionList
              );
              this.start +=
                response.settledTransactions.settledTransactionList?.length;
            }
          } else {
            this.transactions = response;
            this.start += 10;
          }
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    downloadStatement() {
      this.$router.push({ name: 'Credit Statement download statement', params: { amount: this.creditStatementDataProps?.pendingTransactions.outstandingAmount, id: undefined } });
    },
  },
};
</script>
<style scoped>
.colorText_0{
  color: #F45C5F;
}
.colorText_1{
  color: #6AC259;
}
.colorText_2{
  color: #377CFD;
}
.colorText_3{
  color: #FD7F5B;
}
</style>
